import * as AccountSettingsService from './accountSettingsService';
import * as BannerService from './bannerService';
import * as DailyQuizService from './dailyQuizService';
import * as DashboardService from './dashboardService';
import * as FriendProfileService from './friendProfileService';
import * as HelpPopupsService from './helpPopupsService';
import * as ManageSubscriptionService from './manageSubscriptionService';
import * as MyFriendsService from './myFriendsService';
import * as NotificationMessageService from './notificationMessageService';
import * as PersonalizedStudyService from './personalizedStudyService';
import * as PracticeExamService from './practiceExamService';
import * as ResourcesService from './resourcesService';
import * as SignUpService from './signUpService';
import * as StudyService from './studyService';
import * as UserService from './userService';

export default {
  UserService,
  StudyService,
  HelpPopupsService,
  DashboardService,
  DailyQuizService,
  AccountSettingsService,
  PracticeExamService,
  FriendProfileService,
  SignUpService,
  MyFriendsService,
  ManageSubscriptionService,
  ResourcesService,
  BannerService,
  NotificationMessageService,
  PersonalizedStudyService,
};
